import { gql } from '@apollo/client';

export const CREATE_ASSET = gql`
  mutation createAsset($data: CreateAssetInput!) {
    createAsset(data: $data) {
      message
      asset {
        id
        title
        description
        categoryKey
        url
      }
    }
  }
`;

export const CREATE_VIDEO_ASSET = gql`
  mutation createVideoAsset($data: CreateVideoAssetInput!) {
    createVideoAsset(data: $data) {
      signedUrl
      uploadId
      asset {
        id
        title
        description
        categoryKey
        url
      }
    }
  }
`;

export const UPDATE_ASSET = gql`
  mutation updateAsset(
    $data: UpdateAssetInput!
    $where: AssetWhereUniqueInput!
  ) {
    updateAsset(data: $data, where: $where) {
      message
      asset {
        id
        title
        description
        categoryKey
        url
      }
    }
  }
`;

export const UPDATE_VIDEO_ASSET = gql`
  mutation updateVideoAsset(
    $data: UpdateVideoAssetInput!
    $where: AssetWhereUniqueInput!
  ) {
    updateVideoAsset(data: $data, where: $where) {
      message
      asset {
        id
        title
        description
        categoryKey
        url
      }
    }
  }
`;

export const DELETE_ASSET = gql`
  mutation deleteAsset($where: AssetWhereUniqueInput!) {
    deleteAsset(where: $where) {
      message
    }
  }
`;

export const UPDATE_VIDEO_ASSET_STATUS = gql`
  mutation updateVideoAssetStatus($peertubeUUID: ID!, $id: ID!) {
    updateVideoAssetStatus(
      where: { id: $id }
      data: { peertubeUUID: $peertubeUUID }
    ) {
      message
    }
  }
`;
